var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgilysysPms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1051.7 407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0299d6;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7fbc42;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #231f20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M532.1,268.3h-15v85.6h-29.9v-216.8h52.4c46.5,0,83,20.8,83,63.5s-39.1,67.7-90.5,67.7ZM538.6,161.2h-21.5v83h15.9c34.8,0,59.6-16.3,59.6-43.9s-24.4-39.1-54-39.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M835.2,137.1h27l15.6,216.8h-28.6l-10.4-168.9-62.5,129.9h-30.6l-62.5-129.9-10.4,168.9h-28.6l15.6-216.8h27l74.2,153.3,74.2-153.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M962.1,357.8c-20.8,0-43.9-4.2-62.2-13l5.9-23.8c15.9,7.5,36.1,12.7,55.7,12.7,28,0,47.2-12.4,47.2-34.8s-21.8-34.5-47.5-46.5c-29.3-13.7-56.6-29.6-56.6-62.2s28-57,69-57,41.7,5.2,56.3,13l-5.5,23.8c-14-7.2-32.9-12.7-50.8-12.7-25.7,0-39.4,10.7-39.4,30.6s9.8,25.4,37.8,39.1c28,13.7,66.4,31.2,66.4,70.6s-33.9,60.2-76.2,60.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysPms);
export default __webpack_public_path__ + "static/media/AgilysysPMS.a6f25ad2d416b96ae767021db00a4967.svg";
export { ForwardRef as ReactComponent };